import React, { Component } from 'react';
import { connect } from 'shalala';
import { Col, Row } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import './Comprobantes.css';

import { useStore } from '../../store';
import ComprobantesList from './list/ComprobantesList';
import ComprobantesSearch from './list/components/ComprobantesSearch';
import ComprobantesTypeFilter from './list/components/ComprobantesTypeFilter';
import ComprobantesItemActions from './list/components/ComprobantesItemActions';
import ComprobantesToolbarActions from './list/components/ComprobantesToolbarActions';

class Comprobantes extends Component {
  state = {
    selectable: false,
    selectedRowKeys: [],
    selectedRows: [],
  };

  componentDidMount() {
    window.setAppTitle('Facturas');
  }

  handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  handleOnRowClick = (data) => {
    this.props.history.push({
      pathname: `/app/comprobantes/${data.uuid}/info`,
      state: {
        data: {
          ...data,
        },
      },
    });
  };

  handleOnToggleSelectableTableItems = () => {
    this.setState({
      selectable: !this.state.selectable,
    });
  };

  handleOnFilterChange = (filters) => {
    this.props.listActions.paginate({
      page: 1,
      ...filters,
    });
  };

  render() {
    const { selectable, selectedRowKeys, selectedRows } = this.state;
    const { filters } = this.props.list;

    return (
      <div className="comprobantes">
        <Row className="mb-1">
          <Col
            sm="12"
            md="9"
          >
            {selectedRowKeys.length > 0 && (
              <div className="mr-3 d-inline-flex pb-2">
                <ComprobantesItemActions
                  selectedRowKeys={selectedRowKeys}
                  selectedRows={selectedRows}
                />
              </div>
            )}

            {selectedRowKeys.length === 0 && <ComprobantesSearch />}
          </Col>
          <Col
            sm="12"
            md="3"
            className="text-right"
          >
            <ComprobantesToolbarActions
              data={filters}
              onToggleSelectableItems={this.handleOnToggleSelectableTableItems}
              onFilterChange={this.handleOnFilterChange}
            />
          </Col>
        </Row>

        <ComprobantesTypeFilter />

        {Guardian.allows('factura.listar') && (
          <ComprobantesList
            selectable={selectable}
            onRowClick={this.handleOnRowClick}
            onRowSelectionChange={this.handleOnRowSelectionChange}
          />
        )}
      </div>
    );
  }
}

const mapState = (store) => {
  return { list: store.app.comprobantes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.app.comprobantes.list };
};

export default connect(useStore, mapState, mapActions)(Comprobantes);
